<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">{{ $route.meta.label }}  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7" >
          <b-form-group label-cols=3 label="Employee Name">
              <b-row>
                <b-col lg="7">
                    <b-form-input v-model="tblData.crewname"></b-form-input>
                </b-col>
                <b-col cols="5">
                  <b-form-group label-cols-md=6 label="Outstanding">
                      <b-form-select v-model="tblData.outstand" :plain="true" :options="YesNoAll"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>                      
          </b-form-group>

        </b-col>
        <b-col lg="5">
          <b-input-group >
            <b-input-group-prepend><label >Employee ID</label></b-input-group-prepend>
              <b-form-input v-model="tblData.crewnik" placeholder="NIK"></b-form-input>
            <b-input-group-append>
                <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover 
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >

        <template v-slot:cell(tglpaym)="data">
          {{data.item.tglpaym | moment('YYYY-MMM-DD')}}
        </template>
        <template v-slot:cell(jumlah)="data">
          {{data.item.jumlah | numFormat}}
        </template>
        <template v-slot:cell(settled)="data">
          {{data.item.settled | numFormat}}
        </template>
        <template v-slot:cell(outstand)="data">
          {{data.item.outstand | numFormat}}
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 15, 20, 25, 30, 35,40,45,50]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
              <b-pagination
                align="right"
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
    .list-of-loan {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: 120px;
        }
      }
    }
    .input-group {
        .input-group-prepend {
          padding-bottom:2px;
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import loan from "../../apis/loan";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showFilter:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      terpilih:{loankey:''},
      pagination:false,
      YesNoAll: dropdown.YesNoAll,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        outstand: '1'
      }
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "crewinfo",
            label: "Karyawan",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Jabatan",
            sortable: true
          },
          {
            key: "departemen",
            label: "Departemen",
            sortable: true
          },
          {
            key: "locationname",
            label: "Location",
            sortable: true
          },
          {
            key: "tglpaym",
            label: "Tgl. Pinjaman",
            thStyle: "width:100px",
          },
          {
            key: "uraian",
            label: "Keterangan"
          },
          {
            key: "docrefer",
            label: "BK/KK Pencairan",
            sortable: true
          },
          {
            key: "jumlah",
            label: "Jml. Pinjaman",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "settled",
            label: "Angsuran Dibayar",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstand",
            label: "Sisa Pinjaman",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ];
      return fields;
    },
  },
  // created: async function() {
  //     const groups = await loan.group();
  //     this.loanGroups = groups.reduce((newArr, item) => {
  //                     newArr.push(item);
  //                 return newArr;
  //             }, [{value:'',text:'---ALL---'}]);
  // },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.loanList) {
            this.tblData[key] = filter.loanList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.loanList.tgl1 || '';
          this.tblData.tgl2=filter.loanList.tgl2 || '';

          this.showFilter=filtered;
          delete filter.loanList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await loan.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await loan.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.crewname = '';
        this.tblData.crewnik =  '';
        this.tblData.outstand =  '';
        this.refresh();
    },
    saveFilter() {
      const keys = ['crewnik','crewname','crewkey','outstand'];
      let filtered = false;
      const loanList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              loanList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          loanList.page=this.tblData.page;
          loanList.limit=this.tblData.limit;
          loanList.sortBy=this.tblData.sortBy;
          loanList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.loanList=loanList;
          this.$store.commit("filter", filter);
      } 
    },    

    add: function() {
        this.saveFilter();
          router.push({name :'accounting.loanfrm'});
    },
    edit: function() {
      if (this.terpilih.loankey) {
        this.saveFilter();
        router.push({name :'accounting.loanfrm', params: { loankey: this.terpilih.loankey}});
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    deleteConfirm() {
      if (this.terpilih.loankey) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await loan.remove(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }        
          }
    },
    rowClicked(record, index) {
      if (this.terpilih.loankey==record.loankey) {
        console.log('terpilih row click: ', this.terpilih);
        this.edit();
      } else {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await loan.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error), 'Error Info',10000);
            }
        }
    },
    close(){
      router.push({path:"home"});
    },    

  }
};
</script>
